import textServices from 'services/text-services'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { NEIGHBARS_ASSETS } from '../constants'

interface ViewingPartyBannerProps {
  id?: string
  onCtaClick: () => void
}

const ViewingPartyBanner = ({ id, onCtaClick }: ViewingPartyBannerProps) => {
  return (
    <section id={id} className="neighbars__viewing-party">
      <picture>
        <source
          media="(min-width: 1024px)"
          srcSet={`${NEIGHBARS_ASSETS}/desktop/neighbars-viewing_party-titulo-desktop1280px.webp`}
        />
        <source
          media="(min-width: 768px)"
          srcSet={`${NEIGHBARS_ASSETS}/tablet/neighbars-viewing_party-titulo-tablet.webp`}
        />
        <img
          className="neighbars__viewing-party-title"
          src={`${NEIGHBARS_ASSETS}/neighbars-viewing_party-titulo-mobile.webp`}
          alt={textServices.findByText(
            'neighbars/viewingParty/title',
            '¡Gana una Viewing Party! para la CHAMPIONS LEAGUE'
          ) as string}
        />
      </picture>
      <p className="neighbars__viewing-party-description">
        {textServices.findByText(
          'neighbars/viewingParty/description',
          'Registra tu edificio y gana una Viewing Party en el área común para disfrutar con tus vecinos.'
        )}
      </p>
      <button
        type="button"
        className="home-v3__button home-v3__button--blue neighbars__viewing-party-cta"
        onClick={() => {
          dlTrackEvent('user_interaction', { action: 'click', element: '¡quiero ganar una vp!', section: 'neighbars' })
          onCtaClick()
        }}
      >
        {textServices.findByText('neighbars/viewingParty/cta', '¡Quiero ganar una VP!')}
      </button>
      <picture>
        <source
          media="(min-width: 1024px)"
          srcSet={`${NEIGHBARS_ASSETS}/desktop/neighbars-viewing_party-logos-desktop1280px.webp`}
        />
        <source
          media="(min-width: 768px)"
          srcSet={`${NEIGHBARS_ASSETS}/tablet/neighbars-viewing_party-logos-tablet.webp`}
        />
        <img
          className="neighbars__viewing-party-logos"
          src={`${NEIGHBARS_ASSETS}/neighbars-viewing_party-logos-mobile.webp`}
          alt="Neighbars by My Heineken"
        />
      </picture>
    </section>
  )
}

export default ViewingPartyBanner
